"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TARGET_FLOWS = [{
  value: 'LemonCoinPurchase',
  label: 'Aquisição de Lemon Coins'
}, {
  value: 'FreemiumFeature',
  label: 'Funcionalidade Freemium'
}];
var RULE_LABELS = {
  FirstPurchaseOnly: 'Apenas primeira compra',
  PurchaseDateWindow: 'Período de datas',
  ServiceValueRange: 'Valor da operação (R$)',
  SpecificBuyer: 'Comprador específico'
};
var emptyForm = {
  code: '',
  description: '',
  targetFlow: 'LemonCoinPurchase',
  discountPercentage: 10,
  validFrom: '',
  validTo: '',
  maxRedemptions: 100
};
var toDateInput = function toDateInput(isoString) {
  return isoString ? isoString.slice(0, 10) : '';
};
var PromoCodeDialog = function PromoCodeDialog(_ref) {
  var _ruleFields$PurchaseD, _ruleFields$PurchaseD2, _ruleFields$ServiceVa, _ruleFields$ServiceVa2, _ruleFields$ServiceVa3, _ruleFields$ServiceVa4;
  var open = _ref.open,
    onClose = _ref.onClose,
    httpClient = _ref.httpClient,
    initialCode = _ref.initialCode,
    onSaved = _ref.onSaved;
  var isEdit = Boolean(initialCode);
  var _useState = (0, _react.useState)(emptyForm),
    _useState2 = _slicedToArray(_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    enabledRules = _useState4[0],
    setEnabledRules = _useState4[1];
  var _useState5 = (0, _react.useState)({}),
    _useState6 = _slicedToArray(_useState5, 2),
    ruleFields = _useState6[0],
    setRuleFields = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    buyerOptions = _useState8[0],
    setBuyerOptions = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedBuyer = _useState0[0],
    setSelectedBuyer = _useState0[1];
  var _useState1 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState1, 2),
    error = _useState10[0],
    setError = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isSaving = _useState12[0],
    setIsSaving = _useState12[1];
  (0, _react.useEffect)(function () {
    if (!open) return;
    if (initialCode) {
      var _fields$SpecificBuyer;
      setForm({
        code: initialCode.code,
        description: initialCode.description || '',
        targetFlow: initialCode.targetFlow,
        discountPercentage: initialCode.discountPercentage,
        validFrom: toDateInput(initialCode.validFrom),
        validTo: toDateInput(initialCode.validTo),
        maxRedemptions: initialCode.maxRedemptions
      });
      var enabled = {};
      var fields = {};
      (initialCode.rules || []).forEach(function (r) {
        enabled[r.ruleType] = true;
        fields[r.ruleType] = r;
      });
      setEnabledRules(enabled);
      setRuleFields(fields);
      // A pessoa (nome) não é persistida no código, só o id - mostra o id até o admin buscar de novo.
      setSelectedBuyer((_fields$SpecificBuyer = fields.SpecificBuyer) !== null && _fields$SpecificBuyer !== void 0 && _fields$SpecificBuyer.buyerProfileId ? {
        id: fields.SpecificBuyer.buyerProfileId,
        name: fields.SpecificBuyer.buyerProfileId,
        role: ''
      } : null);
    } else {
      setForm(emptyForm);
      setEnabledRules({});
      setRuleFields({});
      setSelectedBuyer(null);
    }
    setError(null);
  }, [open, initialCode]);
  var searchBuyers = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(query) {
      var response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (query) {
              _context.n = 1;
              break;
            }
            setBuyerOptions([]);
            return _context.a(2);
          case 1:
            _context.p = 1;
            _context.n = 2;
            return httpClient.get('/backoffice/people/search', {
              params: {
                q: query
              }
            });
          case 2:
            response = _context.v;
            setBuyerOptions(response.data);
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function searchBuyers(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var toggleRule = function toggleRule(ruleType) {
    return function (event) {
      var checked = event.target.checked;
      setEnabledRules(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, ruleType, checked));
      });
      if (!checked) {
        setRuleFields(function (prev) {
          var next = _objectSpread({}, prev);
          delete next[ruleType];
          return next;
        });
        if (ruleType === 'SpecificBuyer') setSelectedBuyer(null);
      }
    };
  };
  var setRuleField = function setRuleField(ruleType, field, value) {
    setRuleFields(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, ruleType, _objectSpread(_objectSpread({}, prev[ruleType]), {}, _defineProperty({
        ruleType: ruleType
      }, field, value))));
    });
  };
  var handleSave = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var rules, payload, _err$response, _err$response2, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            setError(null);
            setIsSaving(true);
            _context2.p = 1;
            rules = Object.keys(enabledRules).filter(function (ruleType) {
              return enabledRules[ruleType];
            }).map(function (ruleType) {
              return ruleFields[ruleType] || {
                ruleType: ruleType
              };
            });
            payload = _objectSpread(_objectSpread({}, form), {}, {
              discountPercentage: Number(form.discountPercentage),
              maxRedemptions: Number(form.maxRedemptions),
              validFrom: new Date(form.validFrom).toISOString(),
              validTo: new Date(form.validTo).toISOString(),
              rules: rules.map(function (r) {
                return {
                  ruleType: r.ruleType,
                  windowFrom: r.windowFrom ? new Date(r.windowFrom).toISOString() : null,
                  windowTo: r.windowTo ? new Date(r.windowTo).toISOString() : null,
                  minValueBRL: r.minValueBRL !== undefined && r.minValueBRL !== '' ? Number(r.minValueBRL) : null,
                  maxValueBRL: r.maxValueBRL !== undefined && r.maxValueBRL !== '' ? Number(r.maxValueBRL) : null,
                  buyerProfileId: r.ruleType === 'SpecificBuyer' ? (selectedBuyer === null || selectedBuyer === void 0 ? void 0 : selectedBuyer.id) || null : null
                };
              })
            });
            if (!isEdit) {
              _context2.n = 3;
              break;
            }
            _context2.n = 2;
            return httpClient.put("/backoffice/promotional-codes/".concat(initialCode.id), payload);
          case 2:
            _context2.n = 4;
            break;
          case 3:
            _context2.n = 4;
            return httpClient.post('/backoffice/promotional-codes', payload);
          case 4:
            onSaved();
            _context2.n = 6;
            break;
          case 5:
            _context2.p = 5;
            _t2 = _context2.v;
            setError(((_err$response = _t2.response) === null || _err$response === void 0 || (_err$response = _err$response.data) === null || _err$response === void 0 ? void 0 : _err$response.Message) || ((_err$response2 = _t2.response) === null || _err$response2 === void 0 || (_err$response2 = _err$response2.data) === null || _err$response2 === void 0 ? void 0 : _err$response2.message) || _t2.message || 'Ocorreu um erro inesperado.');
          case 6:
            _context2.p = 6;
            setIsSaving(false);
            return _context2.f(6);
          case 7:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 5, 6, 7]]);
    }));
    return function handleSave() {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement(_material.Dialog, {
    open: open,
    onClose: onClose,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_material.DialogTitle, null, isEdit ? 'Editar código promocional' : 'Novo código promocional'), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      mt: 1
    }
  }, error && /*#__PURE__*/_react["default"].createElement(_material.Alert, {
    severity: "error"
  }, error), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    label: "C\xF3digo",
    size: "small",
    fullWidth: true,
    disabled: isEdit,
    value: form.code,
    onChange: function onChange(e) {
      return setForm(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          code: e.target.value.toUpperCase()
        });
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    label: "Descri\xE7\xE3o (interna)",
    size: "small",
    fullWidth: true,
    value: form.description,
    onChange: function onChange(e) {
      return setForm(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          description: e.target.value
        });
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    select: true,
    label: "Aplic\xE1vel a",
    size: "small",
    fullWidth: true,
    disabled: isEdit,
    value: form.targetFlow,
    onChange: function onChange(e) {
      return setForm(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          targetFlow: e.target.value
        });
      });
    }
  }, TARGET_FLOWS.map(function (f) {
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
      key: f.value,
      value: f.value
    }, f.label);
  })), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      display: 'flex',
      gap: 2
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    label: "Desconto (%)",
    type: "number",
    size: "small",
    fullWidth: true,
    inputProps: {
      min: 1,
      max: 100
    },
    value: form.discountPercentage,
    onChange: function onChange(e) {
      return setForm(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          discountPercentage: e.target.value
        });
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    label: "Limite de resgates",
    type: "number",
    size: "small",
    fullWidth: true,
    inputProps: {
      min: 1
    },
    value: form.maxRedemptions,
    onChange: function onChange(e) {
      return setForm(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          maxRedemptions: e.target.value
        });
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      display: 'flex',
      gap: 2
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    label: "V\xE1lido de",
    type: "date",
    size: "small",
    fullWidth: true,
    InputLabelProps: {
      shrink: true
    },
    value: form.validFrom,
    onChange: function onChange(e) {
      return setForm(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          validFrom: e.target.value
        });
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    label: "V\xE1lido at\xE9",
    type: "date",
    size: "small",
    fullWidth: true,
    InputLabelProps: {
      shrink: true
    },
    value: form.validTo,
    onChange: function onChange(e) {
      return setForm(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          validTo: e.target.value
        });
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "subtitle2",
    sx: {
      color: '#f77513',
      fontWeight: 'bold',
      mt: 1
    }
  }, "Regras"), /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      checked: !!enabledRules.FirstPurchaseOnly,
      disabled: !!enabledRules.SpecificBuyer,
      onChange: toggleRule('FirstPurchaseOnly')
    }),
    label: RULE_LABELS.FirstPurchaseOnly
  }), /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      checked: !!enabledRules.PurchaseDateWindow,
      onChange: toggleRule('PurchaseDateWindow')
    }),
    label: RULE_LABELS.PurchaseDateWindow
  }), enabledRules.PurchaseDateWindow && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      display: 'flex',
      gap: 2,
      pl: 4
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    label: "De",
    type: "date",
    size: "small",
    fullWidth: true,
    InputLabelProps: {
      shrink: true
    },
    value: toDateInput((_ruleFields$PurchaseD = ruleFields.PurchaseDateWindow) === null || _ruleFields$PurchaseD === void 0 ? void 0 : _ruleFields$PurchaseD.windowFrom),
    onChange: function onChange(e) {
      return setRuleField('PurchaseDateWindow', 'windowFrom', e.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    label: "At\xE9",
    type: "date",
    size: "small",
    fullWidth: true,
    InputLabelProps: {
      shrink: true
    },
    value: toDateInput((_ruleFields$PurchaseD2 = ruleFields.PurchaseDateWindow) === null || _ruleFields$PurchaseD2 === void 0 ? void 0 : _ruleFields$PurchaseD2.windowTo),
    onChange: function onChange(e) {
      return setRuleField('PurchaseDateWindow', 'windowTo', e.target.value);
    }
  })), /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      checked: !!enabledRules.ServiceValueRange,
      onChange: toggleRule('ServiceValueRange')
    }),
    label: RULE_LABELS.ServiceValueRange
  }), enabledRules.ServiceValueRange && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      display: 'flex',
      gap: 2,
      pl: 4
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    label: "M\xEDnimo (R$)",
    type: "number",
    size: "small",
    fullWidth: true,
    value: (_ruleFields$ServiceVa = (_ruleFields$ServiceVa2 = ruleFields.ServiceValueRange) === null || _ruleFields$ServiceVa2 === void 0 ? void 0 : _ruleFields$ServiceVa2.minValueBRL) !== null && _ruleFields$ServiceVa !== void 0 ? _ruleFields$ServiceVa : '',
    onChange: function onChange(e) {
      return setRuleField('ServiceValueRange', 'minValueBRL', e.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    label: "M\xE1ximo (R$)",
    type: "number",
    size: "small",
    fullWidth: true,
    value: (_ruleFields$ServiceVa3 = (_ruleFields$ServiceVa4 = ruleFields.ServiceValueRange) === null || _ruleFields$ServiceVa4 === void 0 ? void 0 : _ruleFields$ServiceVa4.maxValueBRL) !== null && _ruleFields$ServiceVa3 !== void 0 ? _ruleFields$ServiceVa3 : '',
    onChange: function onChange(e) {
      return setRuleField('ServiceValueRange', 'maxValueBRL', e.target.value);
    }
  })), /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      checked: !!enabledRules.SpecificBuyer,
      disabled: !!enabledRules.FirstPurchaseOnly,
      onChange: toggleRule('SpecificBuyer')
    }),
    label: RULE_LABELS.SpecificBuyer
  }), enabledRules.SpecificBuyer && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      pl: 4
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Autocomplete, {
    size: "small",
    options: buyerOptions,
    getOptionLabel: function getOptionLabel(o) {
      return o.role ? "".concat(o.name, " (").concat(o.role === 'Consultant' ? 'Consultor' : 'Talento', ")") : o.name;
    },
    value: selectedBuyer,
    onChange: function onChange(e, value) {
      return setSelectedBuyer(value);
    },
    onInputChange: function onInputChange(e, value) {
      return searchBuyers(value);
    },
    isOptionEqualToValue: function isOptionEqualToValue(o, v) {
      return o.id === v.id;
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_material.TextField, _extends({}, params, {
        label: "Buscar comprador por nome"
      }));
    }
  }))), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    onClick: onClose,
    style: {
      color: '#666'
    }
  }, "Cancelar"), /*#__PURE__*/_react["default"].createElement(_material.Button, {
    onClick: handleSave,
    disabled: isSaving || !form.code || !form.validFrom || !form.validTo,
    variant: "contained",
    style: {
      backgroundColor: '#f77513',
      color: 'white'
    }
  }, "Salvar")));
};
var _default = exports["default"] = PromoCodeDialog;